import React from 'react'

import { PageSource } from '@mc/track-event'

import CTA from 'components/CTA'

export const Cta = ({ slug }: { slug: string }) => (
  <CTA
    fullWidth
    trackProps={{
      category: slug,
      content_type: 'product',
      location: 'hero',
      page_source: PageSource.CATEGORY,
    }}
  />
)
